const sidebarOptions = [
  { label: "Published", value: "published" },
  { label: "Draft", value: "drafted" },
  { label: "Deleted", value: "deleted" },
  { label: "Submissions", value: "submissions" },
];

const sidebarValueConstants = {
  deleted: "deleted",
  drafted: "drafted",
  published: "published",
  submissions: "submissions"
};

const getCardLastEditedOn = (updatedAt: string) => {
  const editedDate = new Date(updatedAt).toLocaleString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  return `Last Updated: ${editedDate}`;
};

const getOrganizedDataProvider = (formData: any) => {
  if (formData) {
    return {
      deleted: formData.filter((form: any) => form.isActive === 0),
      drafted: formData.filter(
        (form: any) => form.isActive === 1 && form.isPublished === 0
      ),
      published: formData.filter(
        (form: any) => form.isActive === 1 && form.isPublished === 1
      ),
    };
  } else {
    return {
      deleted: [],
      drafted: [],
      published: [],
    };
  }
};

export {
  getCardLastEditedOn,
  getOrganizedDataProvider,
  sidebarOptions,
  sidebarValueConstants,
};
